/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const orderPaymentMethodEnumSchema = z
	.enum(["PARTIAL", "FULL_ONLY", "DISABLED"])
	.describe("* `PARTIAL` - Разрешить частичную оплату\n* `FULL_ONLY` - Разрешить только полную оплату\n* `DISABLED` - Запретить оплату");
